import { type SearchRequest } from '@searchkit/api';
import { merge } from 'merge-anything';

import { type BettingInsightsSortConfig } from '~/configuration/betting-insights/elasticsearch/BettingInsightsElasticSearch';
import { type PositiveEvIndex } from '~/configuration/betting-insights/types';
import { convertSortingConfigToSortingValue } from '~/utils/convertSortingConfigToSortingValue';

export const positiveEvQueryFactory =
	({ sorting }: { sorting?: BettingInsightsSortConfig<PositiveEvIndex>[] }) =>
	(searchRequest: SearchRequest): SearchRequest => {
		const indexName = searchRequest.indexName;
		const { hitsPerPage } = searchRequest.request.params ?? { hitsPerPage: 10 };

		const activeSort = sorting?.find(
			sort =>
				`${indexName}${convertSortingConfigToSortingValue(sort)}` ===
				searchRequest.request.indexName,
		) ?? {
			field: 'expectedValue',
			order: 'desc',
		};

		const sort = {
			[activeSort.field]: activeSort.order,
		};

		const query = merge(searchRequest, {
			body: {
				size: hitsPerPage,
				...(activeSort.field === 'sportsData.hitRates.last10'
					? {
							query: {
								bool: {
									must: [
										{
											exists: {
												field: 'sportsData.hitRates.last10',
											},
										},
									],
									must_not: [
										{
											term: {
												'sportsData.hitRates.last10': 0,
											},
										},
									],
								},
							},
						}
					: {}),
				sort: [sort, { oddsDecimal: 'desc' }],
				collapse: {
					field: 'betId',
				},
				aggs: {
					unique_bets: {
						cardinality: {
							field: 'betId',
						},
					},
				},
			},
		});

		return query;
	};
